import React from 'react';
//import PosContents from './PosContents';
//import PosCalculator from './PosCalculator';

const ProductTab = () => {

  const insertMemo = () => {}

    return(
  
        <div className="card">
          <div className="card-body">
              

          <h5 className="card-title">Product related contents</h5>


          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">재고관리</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">메모/변경이력</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">판매이력</button>
            </li>

          </ul>


          <div className="tab-content pt-2" id="myTabContent">


            
          <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">

<div className="row mb-3">
  <p><b>현재 재고수량: 3개</b> (총 입고 120, 판매 100, 반품 7)</p>
  <label className="col-sm-2 col-form-label">구분</label>
  <div className="col-sm-4">
    <select className="form-select" aria-label="Default select example" name="productType" onChange={insertMemo} defaultValue={'income'}>
      <option value="income">입고</option>
      <option value="stolen">도난</option>
      <option value="discard">폐기</option>
      <option value="return">반품</option>
      <option value="trash">샘플</option>
    </select>
  </div>
  <div className="col-sm-4">
    <input className="form-control" type="number" name="quantity" defaultValue={0} />
  </div>                
  <div className="col-sm-2">
    <button type="button" className="btn btn-primary" onClick={insertMemo}>재고입력</button>
  </div>
  <br /><br />

  <table className="table table-hover">
    <thead>
      <tr>
        <th scope="col">구분</th>
        <th scope="col">수량</th>
        <th scope="col">날짜</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>입고</td>
        <td>4</td>
        <td><code>2024-10-23 15:23:36</code></td>
      </tr>
      <tr>
        <td>반품</td>
        <td>3</td>
        <td><code>2024-10-23 15:23:36</code></td>
      </tr>
      <tr>
        <td>도난</td>
        <td>1</td>
        <td><code>2024-10-23 15:23:36</code></td>
      </tr>
      <tr>
        <td>입고</td>
        <td>4</td>
        <td><code>2024-10-23 15:23:36</code></td>
      </tr>            
    </tbody>
  </table>


</div>

</div>


            <div className="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">

              <p>총 판매수량: 23개</p>

              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">구분</th>
                    <th scope="col">회원</th>
                    <th scope="col">수량</th>
                    <th scope="col">금액</th>
                    <th scope="col">날짜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>판매</td>
                    <td>ningiri</td>
                    <td>1</td>
                    <td>￥1,200</td>
                    <td><code>2024-10-23 15:23:36</code></td>
                  </tr>
                  <tr>
                    <td>환불</td>
                    <td>판매</td>
                    <td>1</td>
                    <td>￥1,200</td>
                    <td><code>2024-10-23 15:23:36</code></td>
                  </tr>
           
                </tbody>
              </table>

            </div>




            <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">memo</label>
                <div className="col-sm-10">
                  <textarea className="form-control" style={{height:"100px"}} name="productDescription" onChange={insertMemo} defaultValue={''}>
                  </textarea>
                </div>
              </div>

              <div className="row mb-3">
                <label className="col-sm-2 col-form-label">변경이력/메모</label>
                <div className="col-sm-10">

                  <table className="table table-hover">
                    <tbody>
                      <tr>
                        <td>메모메모메모메모메메모메모메모메모메메모메모메모메모메메모메모메모메모메<br />메모메모메모메모메<br /><code>2024-10-23 15:23:36</code></td>
                      </tr>
                      <tr>
                        <td>상품금액 변경 : 5,000 → 4,000<br /><code>2024-10-23 15:23:36</code></td>
                      </tr>
              
                    </tbody>
                  </table>

                </div>                  
              </div>




            </div>

          </div>



          </div>
        </div>



    );
}

export default ProductTab;




